/* Rippa Perth — storefront interactions */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var moneyFormat = (window.RP && RP.moneyFormat) || '${{amount}}';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = withCommas;
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1]);
  }
  function imgSize(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------------- Panels (drawers / search) ---------------- */
  var scrim = null;
  var openPanel = null;
  var lastFocus = null;

  function open(id) {
    var panel = document.getElementById(id);
    if (!panel) return false;
    if (openPanel && openPanel !== panel) close();
    lastFocus = document.activeElement;
    panel.classList.add('is-open');
    scrim && scrim.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    openPanel = panel;
    var focusTarget = panel.querySelector('input[type="search"]') || panel.querySelector('button, a');
    setTimeout(function () { focusTarget && focusTarget.focus({ preventScroll: true }); }, 60);
    if (panel.hasAttribute('data-rp-cart')) Cart.refresh();
    return true;
  }
  function close() {
    if (!openPanel) return;
    var id = openPanel.id;
    openPanel.classList.remove('is-open');
    scrim && scrim.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openPanel = null;
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-rp-open]');
    if (opener) {
      // Cart page itself: let the link work normally
      if (opener.getAttribute('data-rp-open') === 'rp-cart' && /\/cart\/?$/.test(location.pathname)) return;
      if (open(opener.getAttribute('data-rp-open'))) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-rp-close]') || e.target.closest('[data-rp-scrim]')) {
      var link = e.target.closest('a[href]');
      close();
      if (link && link.getAttribute('href').charAt(0) === '#') return; // allow anchor jump
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------------- Header ---------------- */
  function initHeader() {
    var hdr = $('[data-rp-header]');
    scrim = $('[data-rp-scrim]');
    if ($('[data-rp-mbar]')) document.body.classList.add('rp-has-mbar');
    if (!hdr) return;

    var ticking = false;
    function onScroll() {
      hdr.classList.toggle('is-scrolled', window.scrollY > 24);
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    onScroll();

    // Solid header while a mega menu is open over the hero
    $$('.rp-nav > li', hdr).forEach(function (li) {
      if (!li.querySelector('.rp-mega')) return;
      li.addEventListener('mouseenter', function () { hdr.classList.add('is-hover'); });
      li.addEventListener('mouseleave', function () { hdr.classList.remove('is-hover'); });
      li.addEventListener('focusin', function () { hdr.classList.add('is-hover'); });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) hdr.classList.remove('is-hover'); });
    });

    // Rotating announcement messages
    var ticker = $('[data-rp-ticker]', hdr);
    if (ticker && ticker.children.length > 1 && !reduceMotion) {
      var i = 0;
      setInterval(function () {
        var items = ticker.children;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4200);
    }
  }

  /* ---------------- Predictive search ---------------- */
  function initSearch() {
    var input = $('[data-rp-search-input]');
    var results = $('[data-rp-search-results]');
    if (!input || !results) return;
    var timer, controller;

    function render(products, q) {
      if (!q) { results.innerHTML = ''; return; }
      if (!products.length) {
        results.innerHTML = '<div class="rp-wrap" style="padding:24px var(--rp-gutter);color:var(--rp-muted)">No matches for “' + esc(q) + '”. Try “excavator” or “bucket”.</div>';
        return;
      }
      var html = '<div class="rp-wrap rp-search__grid">';
      products.forEach(function (p) {
        html += '<a class="rp-search__item" href="' + esc(p.url) + '">' +
          (p.image ? '<img src="' + esc(imgSize(p.image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '') +
          '<div><strong>' + esc(p.title) + '</strong><span>' + esc(formatMoney(Math.round(parseFloat(p.price) * 100))) + '</span></div></a>';
      });
      html += '</div><div class="rp-wrap" style="padding-bottom:22px"><a class="rp-link" href="' + root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for “' + esc(q) + '” <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a></div>';
      results.innerHTML = html;
    }

    function query(q) {
      if (controller) controller.abort();
      if (!q) return render([], '');
      controller = window.AbortController ? new AbortController() : null;
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (data) { render((data.resources && data.resources.results.products) || [], q); })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      timer = setTimeout(function () { query(q); }, 180);
    });
    $$('[data-rp-chip]').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = chip.getAttribute('data-rp-chip');
        query(input.value);
        input.focus();
      });
    });
  }

  /* ---------------- Cart ---------------- */
  var Cart = {
    body: null, foot: null, drawer: null,
    init: function () {
      this.drawer = $('[data-rp-cart]');
      if (!this.drawer) return;
      this.body = $('[data-rp-cart-body]', this.drawer);
      this.foot = $('[data-rp-cart-foot]', this.drawer);
      var json = $('[data-rp-cart-json]');
      if (json) { try { this.render(JSON.parse(json.textContent)); } catch (e) {} }

      var self = this;
      this.body.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-rp-qty]');
        if (!btn) return;
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-rp-qty'), 10);
        self.change(key, qty);
      });

      // Legacy theme add-to-cart (product pages) fires `cart-add`
      document.addEventListener('cart-add', function () { self.refresh().then(function () { open('rp-cart'); }); });
      document.addEventListener('cart-change', function (e) { if (e.detail && e.detail.items) self.render(e.detail); });

      // Quick add buttons on product cards
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-rp-add]');
        if (!btn) return;
        e.preventDefault();
        btn.disabled = true;
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-rp-add'), 10), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
          .then(function () { return self.refresh(); })
          .then(function () { open('rp-cart'); })
          .catch(function (err) { alert((err && (err.description || err.message)) || 'Sorry, this item could not be added.'); })
          .then(function () { btn.disabled = false; });
      });
    },
    refresh: function () {
      var self = this;
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },
    change: function (key, quantity) {
      var self = this;
      this.drawer.classList.add('is-loading');
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () {})
        .then(function () { self.drawer.classList.remove('is-loading'); });
    },
    render: function (cart) {
      $$('[data-rp-cart-count]').forEach(function (el) {
        var prev = el.getAttribute('data-count');
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
        if (prev !== String(cart.item_count)) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
      });
      $$('.js-rippa-nav-cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      var countText = $('[data-rp-cart-count-text]');
      if (countText) countText.textContent = '(' + cart.item_count + ')';
      if (!this.body) return;

      if (!cart.item_count) {
        this.body.innerHTML = '<div class="rp-cart__empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 8h14l-1 13H6L5 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg><strong style="color:var(--rp-text);font-size:18px">Your cart is empty</strong><p>Let’s find the right machine for the job.</p><a class="rp-btn rp-btn--primary" href="' + root + 'collections/all">Browse machines</a></div>';
        this.foot && (this.foot.hidden = true);
        return;
      }
      var html = '';
      cart.items.forEach(function (item) {
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="rp-line__variant">' + esc(item.variant_title) + '</div>' : '';
        html += '<div class="rp-line">' +
          '<a class="rp-line__img" href="' + esc(item.url) + '">' + (item.image ? '<img src="' + esc(imgSize(item.image, 200)) + '" alt="" width="84" height="84" loading="lazy">' : '') + '</a>' +
          '<div><a class="rp-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant +
          '<div class="rp-line__row"><div class="rp-qty">' +
          '<button type="button" aria-label="Decrease quantity" data-rp-qty="' + (item.quantity - 1) + '" data-key="' + esc(item.key) + '">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" aria-label="Increase quantity" data-rp-qty="' + (item.quantity + 1) + '" data-key="' + esc(item.key) + '">+</button>' +
          '</div><span class="rp-line__price">' + esc(formatMoney(item.final_line_price)) + '</span></div>' +
          '<button type="button" class="rp-line__remove" data-rp-qty="0" data-key="' + esc(item.key) + '">Remove</button></div></div>';
      });
      this.body.innerHTML = html;
      if (this.foot) {
        this.foot.hidden = false;
        var total = $('[data-rp-cart-total]', this.foot);
        if (total) total.textContent = formatMoney(cart.total_price);
      }
    }
  };

  /* ---------------- Rails (horizontal carousels) ---------------- */
  function initRails(scope) {
    $$('[data-rp-rail]', scope).forEach(function (rail) {
      if (rail._rp) return; rail._rp = true;
      var track = $('.rp-rail__track', rail);
      var section = rail.closest('.rp-section') || rail.parentNode;
      var prev = $('[data-rp-prev]', section);
      var next = $('[data-rp-next]', section);
      var bar = $('.rp-rail__progress span', rail);
      if (!track) return;
      function step() { var c = track.children[0]; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 20) : track.clientWidth; }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        if (bar) {
          var visible = track.clientWidth / track.scrollWidth * 100;
          bar.style.setProperty('--p', Math.max(visible, 8) + '%');
          bar.style.setProperty('--o', (max > 0 ? (track.scrollLeft / max) * (100 - visible) : 0) + '%');
        }
      }
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------------- Model showcase tabs ---------------- */
  function initShowcase(scope) {
    $$('[data-rp-show]', scope).forEach(function (show) {
      if (show._rp) return; show._rp = true;
      var tabs = $$('[role="tab"]', show);
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !on;
          if (on && !reduceMotion) { panel.classList.remove('is-anim'); void panel.offsetWidth; panel.classList.add('is-anim'); }
        });
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* ---------------- Counters & reveal ---------------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-rp-count'));
    var decimals = (el.getAttribute('data-rp-count').split('.')[1] || '').length;
    if (isNaN(target) || reduceMotion) return;
    var start = null, dur = 1600;
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = (target * eased).toFixed(decimals);
      if (p < 1) requestAnimationFrame(frame); else el.textContent = target.toFixed(decimals);
    }
    requestAnimationFrame(frame);
  }

  function initReveal(scope) {
    var items = $$('[data-rp-reveal], [data-rp-count]', scope);
    if (!('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('is-in');
        if (el.hasAttribute('data-rp-count')) animateCount(el);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }


  /* ---------------- Product enquiry ---------------- */
  function initEnquiry() {
    var panel = document.getElementById('rp-enquire');
    if (!panel) return;
    var box = $('[data-rp-enq-product]', panel);
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rp-enquire]');
      if (!btn) return;
      e.preventDefault();
      var d = btn.dataset;
      $$('[data-rp-enq-field]', panel).forEach(function (f) { f.value = d[f.getAttribute('data-rp-enq-field')] || ''; });
      if (box) {
        box.hidden = !d.title;
        $('[data-rp-enq-title]', box).textContent = d.title || '';
        $('[data-rp-enq-price]', box).textContent = d.price || '';
        var img = $('[data-rp-enq-img]', box);
        if (d.image) { img.src = d.image; img.hidden = false; } else { img.hidden = true; }
      }
      var ok = $('[data-rp-enquiry-ok]', panel);
      if (ok) ok.remove();
      open('rp-enquire');
    });
    // Re-open after submitting so the customer sees the confirmation.
    // The ok/error element is only rendered after a post, so its presence is the
    // reliable signal; the #rp-enquiry-form fragment does not always survive the
    // redirect, and relying on it left customers with no feedback at all.
    if ($('[data-rp-enquiry-ok]', panel)) {
      open('rp-enquire');
    }
  }

  /* ---------------- Guide table of contents ---------------- */
  function initToc() {
    var toc = $('[data-rp-toc]'); var src = $('[data-rp-toc-source]');
    if (!toc || !src) return;
    var hs = $$('h2', src); if (hs.length < 3) return;
    var list = $('ol', toc);
    hs.forEach(function (h, i) {
      if (!h.id) h.id = (h.textContent || 'section').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || ('section-' + i);
      var li = document.createElement('li'); var a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); list.appendChild(li);
    });
    toc.hidden = false;
  }

  /* ---------------- Live filter (resource hub, sitemap) ---------------- */
  function initFilter() {
    var input = $('[data-rp-filter-input]');
    var chips = $$('[data-rp-filter-cat]');
    if (!input && !chips.length) return;
    var items = $$('[data-rp-filter-item]');
    var groups = $$('[data-rp-filter-group]');
    var empty = $('[data-rp-filter-empty]');
    var cat = 'all';
    function apply() {
      var q = input ? input.value.trim().toLowerCase() : '';
      var words = q.split(/\s+/).filter(Boolean);
      items.forEach(function (el) {
        var hay = el.getAttribute('data-rp-filter-item') || '';
        var okText = words.every(function (w) { return hay.indexOf(w) > -1; });
        var okCat = cat === 'all' || el.getAttribute('data-cat') === cat;
        el.hidden = !(okText && okCat);
      });
      var anyVisible = false;
      groups.forEach(function (g) {
        var groupItems = $$('[data-rp-filter-item]', g);
        var visible = groupItems.some(function (el) { return !el.hidden; });
        var catOk = cat === 'all' || g.getAttribute('data-rp-filter-group') === cat || !g.hasAttribute('data-rp-filter-group') || chips.length === 0;
        g.hidden = groupItems.length ? !visible : !!q;
        if (!g.hidden) anyVisible = true;
        if (q) $$('details', g).forEach(function (d) { d.open = true; });
        $$('.rp-sm-panel--card, .rp-sm__sub, details.rp-sm-panel', g).forEach(function (p) {
          var pi = $$('[data-rp-filter-item]', p);
          if (pi.length) p.hidden = !pi.some(function (el) { return !el.hidden; });
        });
      });
      if (empty) empty.hidden = anyVisible;
    }
    if (input) input.addEventListener('input', apply);
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.classList.toggle('is-active', x === c); });
        cat = c.getAttribute('data-rp-filter-cat');
        apply();
      });
    });
  }

  /* ---------------- Boot ---------------- */
  function initScope(scope) {
    initRails(scope);
    initShowcase(scope);
    initReveal(scope);
  }

  function boot() {
    initHeader();
    initSearch();
    Cart.init();
    initEnquiry();
    initToc();
    initFilter();
    initScope(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-rp-header]')) { initHeader(); initSearch(); Cart.init(); }
    initScope(e.target);
    $$('[data-rp-reveal]', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });

  window.RPCart = Cart;
})();
